
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { formatDistanceToNow } from 'date-fns';
import { ptBR, enUS, es } from 'date-fns/locale';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import permission from '@/mixins/permission';

import PageHeader from '@/components/PageHeader/PageHeader.vue';
import Ranking from '@/components/Ranking/index.vue';
import Footer from '@/components/Footer/Footer.vue';
import ExSelect from '@/components/Input/Select/Select.vue';
import LastVideo from '@/widgets/Video/LastVideo/LastVideo.vue';
import RealtimeUsers from '@/widgets/Users/RealtimeUsers/RealtimeUsers.vue';
import iSearch from '@/assets/icons/Search.vue';
import Arrow from '@/assets/icons/Arrow.vue';

import UserItem from './components/UserItem/index.vue';
import ChatMessages from './components/ChatMessages/index.vue';

import { SelectData, Institution, Teacher } from './interface';

@Component({
  components: {
    ExSelect,
    UserItem,
    ChatMessages,
    PageHeader,
    iSearch,
    Arrow,
    Ranking,
    LastVideo,
    RealtimeUsers,
    Footer
  }
})
export default class Messages extends Mixins(permission) {
  @Prop() isWidget!: boolean;
  showChat = true;
  showStudentList = true;
  isLoadingInstitution = false;
  windowWidth = window.innerWidth;
  messageSend = '';
  search = '';
  selectData = {} as SelectData;
  messages = [
    {
      userId: 2145147,
      text: 'Oi, tudo bem?',
      id: 1,
      timer: '10h32'
    },
    {
      userId: 2,
      text:
        'Lorem ipsum dolor sit amet consectetur. Justo maecenas netus nulla enim. Egestas lobortis donec mi id tortor aliquet leo est. Faucibus tellus nulla morbi aliquet accumsan vitae varius etiam pellentesque. In malesuada arcu consectetur sit. Euismod tincidunt tempus purus scelerisque luctus commodo consequat nec.',
      id: 2,
      timer: '10h32'
    },
    {
      userId: 2145147,
      text:
        'Lorem ipsum dolor sit amet consectetur. Justo maecenas netus nulla enim. Egestas lobortis donec mi id tortor aliquet leo est. Faucibus tellus nulla morbi aliquet accumsan vitae varius etiam pellentesque. In malesuada arcu consectetur sit. Euismod tincidunt tempus purus scelerisque luctus commodo consequat nec.',
      id: 3,
      timer: '10h32'
    },
    {
      userId: 2,
      text: 'Oi, tudo bem?',
      id: 4,
      timer: '10h32'
    }
  ];
  classes = [];
  institutions = [] as Array<Institution>;
  currentStudentChat = {} as Teacher;
  teachers = [
    {
      id: 1,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2,
      lastDate: this.formatRelativeTime('2025-04-15T10:00:00')
    },
    {
      id: 2,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2,
      lastDate: this.formatRelativeTime('2025-04-16T11:00:00')
    },
    {
      id: 3,
      name: 'John Doe',
      avatar: ''
    },
    {
      id: 4,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 5,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 6,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 7,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 8,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 9,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 10,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 11,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 12,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 13,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 14,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    },
    {
      id: 15,
      name: 'John Doe',
      avatar: 'https://cdn.vuetifyjs.com/images/john.jpg',
      newMessages: 2
    }
  ] as Array<Teacher>;

  mounted() {
    this.initializeBreadcrumb();
    this.getInstitutionByTeacher();

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  get isMobile() {
    return this.windowWidth <= 960;
  }

  get isMobileOrIsWidget() {
    return this.isMobile || this.isWidget;
  }

  get isPlanFree() {
    return this.$store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;
  }

  get isRankingOrFree() {
    return this.can(LIST_PERMISSION.RANKING) || this.isPlanFree;
  }
  
  async getInstitutionByTeacher() {
    try {
      this.isLoadingInstitution = true;

      this.institutions = [];
    } catch (error) {
      this.$store.dispatch('Toast/setToast', {
        text: this.$t('messagesPages.errors.errorLoadingInstitutions'),
        status: 'error'
      });
      console.error(error);
    } finally {
      this.isLoadingInstitution = false;
    }
  }

  selectedClasses(value: string) {
    this.selectData.shiftSelectValue = [value];
  }

  selectedInstitution(value: Institution) {
    this.selectData.institutionSelectValue = [value.institutionID];
  }

  handleChatClick(student: Teacher) {
    const appContainer = document.querySelector('.app-container');
    if (this.isMobileOrIsWidget) {
      this.showStudentList = false;
    }
    this.showChat = true;
    this.currentStudentChat = student;

    if (appContainer) {
      appContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  handleBackList() {
    this.showStudentList = true;
    this.showChat = false;
  }

  handleResize() {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth > 768) {
      this.showStudentList = true;

      if (this.isWidget) {
        this.showChat = false;
      } else {
        this.showChat = true;
      }
    } else {
      this.showStudentList = true;
      this.showChat = false;
    }
  }

  getDateFnsLocale() {
    const currentLocale = this.$i18n.locale;

    switch (currentLocale) {
      case 'en':
        return enUS;
      case 'es':
        return es;
      case 'pt-BR':
      default:
        return ptBR;
    }
  }

  formatRelativeTime(data: Date | string) {
    const date = new Date(data);
    const distance = formatDistanceToNow(date, {
      addSuffix: true,
      locale: this.getDateFnsLocale()
    });

    return distance;
  }

  initializeBreadcrumb() {
    this.$breadcrumb.set([{ title: this.$t('messagesPages.breadcrumbs.messages'), to: null }]);
  }
}
